/**
 * Lake house LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface Pair {
  id?: number;
  basePairId?: number;
  liquidityProviderId?: number;
  active?: boolean;
  baseAssetId?: number;
  quoteAssetId?: number;
  name?: string;
  qtyScale?: number;
  priceScale?: number;
  priceScaleView?: number;
  minQty?: number;
  maxQty?: number;
  minPrice?: number;
  maxPrice?: number;
  metadata?: string;
  stableCoin?: boolean;
  supportHouse?: boolean;
  priceProtection?: boolean;
}
